// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2010":"d20933b4","2222":"e7d1c58e","3259":"b2d5d81a","4083":"9c4e274c","6360":"5b5152f8","6504":"26171a30","7231":"66cced1a","7678":"b4635a04","7768":"b576a74a","8187":"919b0934"}[chunkId] + ".chunk.css";
};